import React from 'react';
import cx from 'classnames';
import '../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../../common/GradientWrapper/index.js';
import { Icon } from '../../../../common/Icon/index.js';
import '../../../../common/LazyImage/index.js';
import '../../../../common/NumberFormat/index.js';
import '../../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const Warning = ({
  v2,
  text = {
    warning: "Warning",
    body: "Please verify your deposit address before each transaction"
  },
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className, {
      [styles.v2]: v2
    }),
    style,
    ...props
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.header }, !v2 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { iconName: "WarningIcon" }), "\xA0", text.warning), v2 && /* @__PURE__ */ React.createElement(Icon, { iconName: "WarningIcon" })),
  /* @__PURE__ */ React.createElement("div", { className: styles.body }, text.body)
);
Warning.displayName = "Forms.WalletForm.Warning";

export { Warning };
//# sourceMappingURL=index.js.map
